import React from 'react';

export default function HomeFeaturedProducts() {
  return (
    <section className="first-products" aria-label="Featured DALMAF products">
      <article
        style={{ cursor: 'pointer' }}
        onClick={() => window.open('https://dplinvestone.com', '_blank')}
      >
        <div
          className="first-product-image investone"
          style={{ backgroundImage: 'url(/assets/investone-clear.png)' }}
        ></div>
        <div>
          <span className="fp-label">Fractional Ownership</span>
          <strong className="fp-name">InvestOne</strong>
        </div>
      </article>
      <article
        style={{ cursor: 'pointer' }}
        onClick={() => window.open('https://dpllexaudit.com', '_blank')}
      >
        <div
          className="first-product-image lexaudit"
          style={{ backgroundImage: 'url(/assets/lexaudit-clear.png)' }}
        ></div>
        <div>
          <span className="fp-label">Audit &amp; Legal Package</span>
          <strong className="fp-name">LexAudit</strong>
        </div>
      </article>
    </section>
  );
}
